import { QueryParams } from "PFTypes/query_params";

export const skillsFrameworksKeys = {
  all: () => ["skillsFrameworks"],
  list: (params: QueryParams = {}) => [...skillsFrameworksKeys.all(), "list", params],
  single: (id: number) => [...skillsFrameworksKeys.all(), id.toString()]
};
